import React,{ useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";

import { TransactionsTabIcon, TransactionsTabIconDone, SettlementsTabIcon, SettlementsTabIconDone } from '../../../../utils/Icons';
import { getTransactionsRequest  } from '../../../../store/OutstandingBalance/actions';
import { setPageMainTitle } from '../../../../utils/Helpers';
import { ROUTE_PATHS } from '../../../../utils/RoutesPaths';
import messages from '../../../../assets/locale/messages';
import Breadcrumbs from '../../../../components/BreadCrumbs';
import Stepper from '../../../../components/Stepper';
import Transactions from './Transactions';
import Settlements from './Settlements';

const ViewProviderOutstandingBalance = () => {

    const dispatch = useDispatch();
    const { id } = useParams();
    const lang = useSelector((state) => state.locale.lang);
    const settlementConfirmationData = useSelector((state) => state.outstandingBalance.settlementConfirmationData);
    const { outStandingBalance } = messages[lang];
    const [tabIndex, setTabIndex] = useState(0);
    const stepperItems = [
        {
            label: outStandingBalance.details.transactions,
            icon: [<TransactionsTabIconDone />, <TransactionsTabIcon />],
        },
        {
            label: outStandingBalance.details.settlements,
            icon: [<SettlementsTabIconDone />, <SettlementsTabIcon />],
        },
    ]

    useEffect(() => {
        setPageMainTitle('settlementsManagement');
    }, []);

    useEffect(()=>{
        dispatch(getTransactionsRequest({
            service_provider_id:id,
        }))
    },[lang]);

    return (
        <div>
            <Breadcrumbs
                list={[
                    {
                        path: ROUTE_PATHS.settlements,
                        label: outStandingBalance.details.settlements,
                    },
                    {
                        path: '#',
                        label: lang === 'en'
                                 ? (<span>
                                        {settlementConfirmationData.service_provider_name}
                                        {outStandingBalance.details.providerOutstandingDetails}
                                   </span>)
                                 : (<span>
                                        {outStandingBalance.details.providerOutstandingDetails}
                                        {settlementConfirmationData.service_provider_name}
                                   </span>)      
                    },
                ]}
                className="fsize-28 fweight-600 mb-5"
            />
            <div
                className="w-50 mx-auto"
            >
                <Stepper
                    steps={stepperItems}
                    handleSelectStep={(index) => setTabIndex(index)}
                    currentStep={tabIndex}
                    allTabsIsClicable={true}
                />
            </div>
            <div className="rounded-4 m-3 mt-5">{tabIndex === 0 && <Transactions />}</div>
            <div className="bg-white rounded-4 m-3 mt-5">{tabIndex === 1 && <Settlements />}</div>
        </div>
    )
};

export default ViewProviderOutstandingBalance;